import { render } from "./AtendimentoUnidadeRelatorio.vue?vue&type=template&id=0ed95136&scoped=true"
import script from "./AtendimentoUnidadeRelatorio.vue?vue&type=script&lang=js"
export * from "./AtendimentoUnidadeRelatorio.vue?vue&type=script&lang=js"

import "./AtendimentoUnidadeRelatorio.vue?vue&type=style&index=0&id=0ed95136&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed95136"]])

export default __exports__